import { AppBar, Box, Button, Container, MenuItem, Select, Toolbar, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { NavLink, Outlet } from "react-router";

import { logout } from "../api/auth-api";
import { useCurrentUser } from "../auth/current-user";
import { LANGUAGES, Language, changeLanguage } from "../i18n/i18n";

const NAVIGATION = [
    { to: "/", label: "nav.costTree", end: true },
    { to: "/unassigned", label: "nav.unassigned", end: false },
    { to: "/status", label: "nav.status", end: false },
] as const;

/** Application frame: navigation, language selection, and logout around the current page. */
export function AppLayout() {
    const { t, i18n } = useTranslation();
    const user = useCurrentUser();

    return (
        <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
            <AppBar position="static">
                <Toolbar sx={{ gap: 2 }}>
                    <Typography variant="h6" component="h1" sx={{ mr: 2 }}>
                        {t("app.title")}
                    </Typography>
                    <Box component="nav" sx={{ display: "flex", gap: 1, flexGrow: 1 }}>
                        {NAVIGATION.map((item) => (
                            <Button
                                key={item.to}
                                component={NavLink}
                                to={item.to}
                                end={item.end}
                                color="inherit"
                                sx={{ "&.active": { textDecoration: "underline" } }}>
                                {t(item.label)}
                            </Button>
                        ))}
                    </Box>
                    <Typography variant="body2">{user.name ?? user.subject}</Typography>
                    <Select
                        size="small"
                        variant="standard"
                        value={i18n.language}
                        inputProps={{ "aria-label": t("nav.language") }}
                        onChange={(event) => {
                            changeLanguage(event.target.value as Language);
                        }}
                        sx={{ color: "inherit", minWidth: 56 }}>
                        {LANGUAGES.map((language) => (
                            <MenuItem key={language} value={language}>
                                {language.toUpperCase()}
                            </MenuItem>
                        ))}
                    </Select>
                    <Button color="inherit" onClick={() => void logout()}>
                        {t("nav.logout")}
                    </Button>
                </Toolbar>
            </AppBar>
            <Container maxWidth="xl" sx={{ py: 3 }}>
                <Outlet />
            </Container>
        </Box>
    );
}
